import RENTAL_OBJECTS from './rental_object.json';
import STORE_NAMES from './store_name.json';
import USER_SETTINGS from './user_setting.json';
import LARVA_SMART_HOME from './larva_smart_home.json';

/**
 * exports names and keys of corresponding local storages
 */
export default { RENTAL_OBJECTS, STORE_NAMES, USER_SETTINGS, LARVA_SMART_HOME };
